<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallTimeSingleList></CallTimeSingleList>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import CallTimeSingleList from '../../../../components/tsConfig/hytalkPro/system/CallTimeSingleList';

export default {
  name: 'SystemCallTimeSingle',
  components: {
    BasicLayout,
    CallTimeSingleList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: '111/22222/33333'
      }
    };
  }
};
</script>

<style scoped>

</style>
